import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { SubSink } from "subsink";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { forkJoin, Observable } from "rxjs";
import { EmitEvent, EventBusService } from "../../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../../shared/logger/nbc-logger.service";
import { SharedDataService } from "../../../../shared/sharedData.service";
import { RemotesQueryService } from "../../../../shared/services/remotesquery.service";
import { OnboardingColorsService } from "../../../../shared/services/onboarding-colors.service";

@Component({
  selector: "onboarding-historygrid",
  templateUrl: "./history-grid-component.html",
  standalone: false
})

export class OnboardingHistoryComponent implements OnInit, OnDestroy {
  constructor(
    private _eventBus: EventBusService,
    private _onboardingColorsService: OnboardingColorsService,
    private _sharedDataService: SharedDataService,
    public _modalService: BsModalService,
    private _remotesQueryService: RemotesQueryService,
    private log: NbcLoggerService
  ) { }


  private subs = new SubSink();
  gridData: any = {
    items: [],
    query: '',
  };

  hasTalentSu: any = false;
  colors: any | undefined;


  setUpRoleAcccess() {
    const userRoles = window.preload?.user?.userRoles || [];
    this.hasTalentSu = _.some(userRoles, {
      description: "Talent SU",
    });
  }



  buildGrid(dataSource: any) {
    this.setUpRoleAcccess();
    this.gridData = dataSource;
    this.gridData.items.forEach((item: any) => {
      _.assign(item, { checked: false });      
      const color= this.colors.requestStatus.get(
        item.onboardngStatusId.toString()
      ); 
      _.assign(item, { checked: false });
      _.assign(item, { requestStatusColor: color });

      if (item.contactType === "Vendor") {
        item.isVendor = true;
      } else {
        item.isVendor = false;
      }

    });
  }

  sortOnColumn(columnName: string): void {
    this._eventBus.emit(
      new EmitEvent(
        "onboard-request:sortOnColumn",
        "changeSortColumn",
        columnName
      )
    );
  }



  openOnboardingModal(registrationObject) {
    this._eventBus.emit(
      new EmitEvent(
        "Onboarding-Request:openOnboardingModal",
        "openHrOnboardingPositionModal",
        registrationObject
      )
    );
  }

  initSubs(): void {

    this.subs.sink = this._eventBus.on(
      "buildOnboardingHistoryGrid",
      (dataSource) => this.buildGrid(dataSource)
    );

  }

  ngOnInit() {
    this.gridData.query = this._remotesQueryService.getHrOnboardingHistoryTabQuery();
    this.colors = this._onboardingColorsService.getColors();
    this.initSubs();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
